import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useRosterStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Roster Templates loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Roster Templates loader'
  )

  const getRosterTemplates = useRosterStore
    .getState()
    .getRosterTemplates(useRosterStore.getState().showDeactivated)

  return defer({
    data: Promise.all([getRosterTemplates])
      .then(() => true)
      .catch((error) => {
        logger.error('Roster Templates Promise.all error', error)
        return false
      }),
  })
}
